<template>
	<div class="home">
		<div class="home-header" style="background-color: white; top: 0px;">
			<div class="header-content">
				<div class="search" @click="tosearch">
					<div class="search-div">
						<span class="icon-homepage_search"></span>
						输入商品名或粘贴淘宝标题
					</div>
				</div>
				<div class="right-icon" @click="tokefu"><span class="iconfont icon-kefu-"></span></div>
			</div>
		</div>

		<van-pull-refresh v-model="isLoading" @refresh="onRefresh" :headHeight="100">
			<van-swipe :autoplay="3000" indicator-color="white" v-if="images.length > 0" class="banner">
				<van-swipe-item v-for="(item, index) in images" :key="index"><img v-lazy="item.picture" /></van-swipe-item>
			</van-swipe>

			<div class="goods">
				<nut-infiniteloading @loadmore="onInfinite" :is-show-mod="true" :has-more="isHasMore" :is-loading="isGoodsLoading" :threshold="200">
					<cst-goods :product="CouponData" @detail="detail"></cst-goods>
				</nut-infiniteloading>
			</div>
		</van-pull-refresh>

		<nut-backtop :distance="400"></nut-backtop>
	</div>
</template>

<script>
import cstGoods from '@/components/product.vue';
export default {
	name: 'home',
	data() {
		return {
			images: [],
			isLoading: false,
			CouponData: [],
			page: 1,
			num: 30,
			isHasMore: true,
			isGoodsLoading: false
		};
	},
	created() {
		this.loadBanner();
		this.loadData();
	},
	destroyed() {
		// 销毁 
	},
	components: {
		cstGoods
	},
	methods: {
		loadBanner() {
			this.$Request.post('index/banner').then(res => {
				if (res.code == 200) {
					this.images = res.data;
				}
			});
		},
		onRefresh() {
			this.page = 1;
			this.loadData();
		},
		loadData() {
			this.isGoodsLoading = true;
			this.$Request.post('product/goodslist', { page: this.page , source: 'home' , limit : 20}).then(res => {
				this.isGoodsLoading = false;
				if (res.code == 200) {
					res.data.forEach(item => {
						this.CouponData.push(item);
					});
				} else {
					this.isHasMore = false;
				}
			});
		},
		onInfinite() {
			this.page = this.page + 1;
			this.loadData();
		},
		detail(e) {
			suni.showLoading()
			suni.navigateTo({
				url: '/pages/detail/goodsinfo?itemid=' + e.itemid + '&goods_type=' + e.shopType
			}).then(res=>{
				suni.hideLoading()
			}).catch(err=>{
				suni.hideLoading();
				suni.showToast({
					title: JSON.stringify(err),
					success: err => {
						console.log(err);
					}
				});
				
			});
		},
		tokefu(){
			suni.showLoading()
			suni.navigateTo({
				url: '/pages/member/ucenter/customService'
			}).then(res=>{
				suni.hideLoading()
			})
		},
		tosearch(){
			suni.showLoading()
			suni.navigateTo({
				url: '/html5/barcode',
				h5:true
			}).then(res=>{
				suni.hideLoading()
			}).catch(err=>{
				suni.hideLoading()
				
				
			})

		}
	}
};
</script>
<style>
.banner {
	height: 180px;
}
.banner img {
	height: 100%;
	    width: 100%;
}
.home .van-pull-refresh {
	margin-top: 40px;
}
.home-header {
	position: fixed;
	top: 0;
	width: 100%;
	z-index: 100;
}
.home-header .header-content {
	height: 40px;
	display: -webkit-box;
	display: -webkit-flex;
	display: flex;
	border-bottom: 1px solid #f6f6f6;
}

.home-header .header-content .search {
	display: -webkit-box;
	display: -webkit-flex;
	display: flex;
	-webkit-box-pack: center;
	-webkit-justify-content: center;
	justify-content: center;
	-webkit-box-align: center;
	-webkit-align-items: center;
	align-items: center;
	-webkit-box-flex: 1;
	-webkit-flex: 1 0 auto;
	flex: 1 0 auto;
	padding-left: 15px;
}
.home-header .header-content .search .search-div {
	height: 30px;
	padding-left: 8px;
	display: -webkit-box;
	display: -webkit-flex;
	display: flex;
	-webkit-box-align: center;
	-webkit-align-items: center;
	align-items: center;
	font-size: 14px;
	color: #848484;
	width: 100%;
	background-color: #eeeeee;
	border-radius: 30px;
	position: relative;
	color: #c3c3c3;
}
.home-header .header-content .search .search-div-opcity {
	display: -webkit-box;
	display: -webkit-flex;
	display: flex;
	-webkit-box-align: center;
	-webkit-align-items: center;
	align-items: center;
	height: 30px;
	padding-left: 10px;
	font-size: 18px;
	color: #848484;
	width: 100%;
	background: rgba(255, 255, 255, 0.5);
	color: white;
	border-radius: 30px;
	position: relative;
}
.home-header .header-content .right-icon {
	color: #999999;
	position: relative;
	display: -webkit-box;
	display: -webkit-flex;
	display: flex;
	-webkit-box-pack: center;
	-webkit-justify-content: center;
	justify-content: center;
	-webkit-box-align: center;
	-webkit-align-items: center;
	align-items: center;
	-webkit-box-flex: 0;
	-webkit-flex: 0 0 50px;
	flex: 0 0 50px;
}
.home-header .header-content .right-icon .icon-kefu- {
	font-size: 22px;
}
.home-header .header-content .right-icon:active {
	opacity: 0.5;
}
.home-header .header-content .right-icon .point-red {
	width: 7px;
	height: 7px;
	background-color: #f64545;
	border-radius: 100%;
	position: absolute;
	right: 13px;
	top: 8px;
}
.gray-icon:before {
	color: #848484 !important;
}

/*goods*/
</style>
